module.exports = __webpack_public_path__ + "img/layout.b811bbae.png";